
export const NODE_WIDTH = 260;
export const GRID_SIZE = 20;

export const CORE_NODE_CATEGORIES = {
  trigger: { label: 'Triggers', color: 'amber', icon: 'fa-bolt' },
  logic: { label: 'Logic', color: 'purple', icon: 'fa-code-branch' },
  action: { label: 'Actions', color: 'blue', icon: 'fa-paper-plane' },
  data: { label: 'Data', color: 'slate', icon: 'fa-database' }
};

export const NODE_TYPES: Record<string, { cat: keyof typeof CORE_NODE_CATEGORIES, label: string, type: string }> = {
  webhook: { cat: 'trigger', label: 'Webhook', type: 'trigger' },
  schedule: { cat: 'trigger', label: 'Schedule', type: 'trigger' },
  manual: { cat: 'trigger', label: 'Manual Input', type: 'input' },
  condition: { cat: 'logic', label: 'If / Else', type: 'condition' },
  switch: { cat: 'logic', label: 'Switch', type: 'processing' },
  script: { cat: 'logic', label: 'Code Block', type: 'script' },
  http: { cat: 'action', label: 'HTTP Request', type: 'http' },
  email: { cat: 'action', label: 'Send Email', type: 'action' },
  response: { cat: 'action', label: 'Return Response', type: 'output' },
  json: { cat: 'data', label: 'JSON Transform', type: 'transform' },
  store: { cat: 'data', label: 'Data Store', type: 'processing' },
};
